/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { useRef, useEffect } from 'react';
var styles = {
  backdropContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 9998,
    // tooltip and dropdown (9999) have to be even higher than modal
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  backdrop: {
    position: 'absolute',
    backgroundColor: 'grey.transparent',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%'
  }
};
var ModalBackdrop = function ModalBackdrop(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick;
  var backdropContainerRef = useRef(null);
  useEffect(function () {
    backdropContainerRef.current.focus();
  }, []);
  return jsx("div", {
    tabIndex: -1,
    onKeyDown: function onKeyDown(event) {
      return event.key === 'Escape' && onClick && onClick(event);
    },
    ref: backdropContainerRef,
    sx: styles.backdropContainer
  }, jsx("div", {
    sx: styles.backdrop,
    onClick: onClick
  }), children);
};
export { ModalBackdrop };